import { connect } from 'react-redux'
import GradeMenu from './GradeMenu'

const mapStateToProps = state => ({
  menuOpen: state.menu.selectedMenu === 'Grades'
})

export default connect(mapStateToProps)(GradeMenu)
